<template>
  <section class="promotion-section">
    <div class="container">
      <h2 class="section-title">
        {{ $t('home.latestNews') }}
      </h2>
      <van-swipe
        :loop="true"
        :autoplay="3000"
        indicator-color="#D4AF37"
        class="promotion-swiper"
      >
        <van-swipe-item
          v-for="(promotion, index) in promotionList"
          :key="index"
          class="swipe-item"
        >
          <PromotionCard :promotion="promotion" />
        </van-swipe-item>
      </van-swipe>
    </div>
  </section>
</template>

<script lang="ts">
import { onMounted, ref, watch } from 'vue'
import PromotionCard from '@/components/home/PromotionCard.vue'
import { Promotion, queryPromotionList } from '@/api/promotion'
import { useI18n } from 'vue-i18n'
export default {
  name: 'PromotionSection',
  components: {
    PromotionCard
  },
  setup () {
    const { locale } = useI18n()
    const promotionList = ref<Promotion[]>([])
    const getPromotionList = () => {
      const params = {
        page: 1,
        size: 5
      }
      queryPromotionList(params).then(res => {
        promotionList.value = res.list
      })
      // const res = await getPromotionList()
      // promotions.value = res.data
    }
    // 监听语言变化
    watch(locale, () => {
      getPromotionList()
    })

    onMounted(() => {
      getPromotionList()
    })
    return {
      promotionList
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.promotion-section {
  padding: $spacing-xxl 0;
  margin: $spacing-xxl 0;
}

.section-title {
  text-align: center;
  font-size: $font-size-xxl;
  font-weight: 700;
  margin-bottom: $spacing-xxl;
  color: $primary-blue;
}

.promotion-swiper {
  border-radius: $border-radius-lg;
  overflow: hidden;
  box-shadow: $card-shadow;
}

.swipe-item {
  padding: $spacing-xs;
}

// 1080×1920 设备适配
@media (min-width: 1080px) and (min-height: 1920px) {
  .promotion-swiper {
    max-width: 90%;
    margin: 0 auto;
  }
}

// 平板设备
@media (max-width: $breakpoint-lg) {
  .promotion-swiper {
    max-width: 90%;
    margin: 0 auto;
  }
}

// 移动端适配
@media (max-width: $breakpoint-md) {
  .section-title {
    font-size: $font-size-xl;
    margin-bottom: $spacing-xl;
  }

  .promotion-swiper {
    max-width: 100%;
  }

  .swipe-item {
    padding: $spacing-xs * 0.5;
  }
}
</style>
